export const TF_DATA_POST_KEYS = {
	CAMPAIGN_NAME: 'campaignName',
	MT_ID: 'mtUser_mtId',
	CET_GROUP_ID: 'cetGroupId',
	NAME: 'fullName',
	VAT_NUMBER: 'vatNumber',
	TF_ID: 'mtUser_tfId',
	TF_NAME: 'mtUser_tfName',
	EMAIL: 'mtUser_email',
	PHONE: 'mtUser_msisdn',
	FLAGS: 'flags',
	INCLUDED_CATEGORIES: 'includedCategories',
	EXCLUDED_CATEGORIES: 'excludedCategories'
};
